import { useCallback, useState } from 'react';

import { timeoutFetchSentryGuard } from 'Fetch';
import { getOfferBids } from 'PrivateApis';

import { Slug } from '../../profiling/@types';

export type EnquiryOfferResponse = {
  bids: {
    createdAt: string;
    value: number;
  }[];
  closingBid: {
    dealerContract: any;
    id: number;
    value: number; // we don't care right now.
  } | null;
  endOfSalePeriod: string;
  enquiryId: number;
  offerExpiry: string;
  state?: {
    slug: Slug;
  };
  vehicle: {
    make: {
      name: string;
    };
    model: string;
  };
  vehicleDetails: {
    vrm: string;
  };
}

const useGetEnquiryOffers = () => {
  const [data, setData] = useState<EnquiryOfferResponse | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetched, setIsFetched] = useState<boolean>(false);

  const getEnquiryOffers = useCallback(async (dpEnquiryId: number) => {
    setIsLoading(true);
    try {
      const response = await getOfferBids(dpEnquiryId);
      setData(response?.closingBid ? response : null);
    } catch (err: any) {
      setData(undefined);
      timeoutFetchSentryGuard(err, () => {
        window.Sentry?.captureException?.(new Error(err), {
          extra: {
            dpEnquiryId,
          },
          tags: {
            fetch: 'Get an enquiry\'s offer',
          },
        });
      });
    }
    setIsLoading(false);
    setIsFetched(true);
  }, []);

  return {
    data,
    getEnquiryOffers,
    isFetched,
    isLoading,
    isSuccess: !!(data || data === null),
  };
};

export default useGetEnquiryOffers;
